<template>
  <div class="w-full !h-full">
    <v-chart
      :options="regularCheckupsData"
      :autoresize="true"
      class="w-full !h-full"
      :init-options="{ devicePixelRatio: 2 }"
      ref="histogramChartRef"
    ></v-chart>
  </div>
</template>

<script>
export default {
  props: {
    regularCheckupsData: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {}
  },
}
</script>

<style>
</style>
